import { NavLink, useLocation } from 'react-router-dom'
import clsx from 'clsx'

interface NavItem {
  label: string
  path: string
  icon: string
}

const navItems: NavItem[] = [
  {
    label: 'Beranda',
    path: '/admin/dashboard',
    icon: '/assets/images/nav_beranda.png',
  },
  {
    label: 'Stadion',
    path: '/admin/stadion',
    icon: '/assets/images/nav_data.png',
  },
  {
    label: 'Laporan',
    path: '/admin/laporan',
    icon: '/assets/images/nav_eksplor.png',
  },
  {
    label: 'Profil',
    path: '/admin/settings',
    icon: '/assets/images/avatar_hijab.png',
  },
]

export default function BottomNav() {
  const location = useLocation()

  const isActive = (path: string) => {
    return location.pathname.startsWith(path)
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-[0_-3px_12px_rgba(0,0,0,0.07)]">
      <div className="max-w-2xl mx-auto flex justify-around items-center h-16">
        {navItems.map((item) => {
          const active = isActive(item.path)
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={clsx(
                'flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-all duration-200',
                active ? 'opacity-100' : 'opacity-60'
              )}
            >
              <div
                className={clsx(
                  'w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200',
                  active ? 'bg-gradient-to-br from-[#F9A028] to-[#F5A623] shadow-md' : ''
                )}
              >
                <img
                  src={item.icon}
                  alt={item.label}
                  className="w-5 h-5 object-contain"
                  style={{ filter: active ? 'brightness(0) invert(1)' : 'none' }}
                />
              </div>
              <span
                className={clsx(
                  'text-[10px] font-medium transition-colors duration-200',
                  active ? 'text-[#F5A623]' : 'text-gray-500'
                )}
              >
                {item.label}
              </span>
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}
